<script lang="ts">
import { defineComponent } from 'vue';
import { AisRefinementList } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  components: {
    AisRefinementList,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
});
</script>
<template>
  <div>
    <button
      :id="`dropdown-${attribute}-toggle`"
      :data-dropdown-toggle="`dropdown-${attribute}-menu`"
      class="relative flex w-full items-center justify-between border-b border-solid border-jordans-sea-blue-dark py-3 text-xl font-medium"
      type="button"
    >
      {{ label }}
      <svg
        ref="chevron"
        class="ml-3 text-white"
        viewBox="0 0 16 16"
        height="16"
        width="16"
        fill="none"
      >
        <path
          d="M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <div
      :id="`dropdown-${attribute}-menu`"
      class="z-40 hidden min-w-[15rem] bg-jordans-sea-blue p-4 shadow-lg"
      :aria-labelledby="`dropdown-${attribute}-toggle`"
    >
      <ais-refinement-list
        :attribute="attribute"
        :limit="100"
        :sort-by="['name:asc']"
        :class-names="{
          'ais-RefinementList-count': 'hidden',
          'ais-RefinementList-checkbox':
            'mr-3 checked:bg-checkbox-sea-blue-dark text-jordans-summer-orange-dark focus:ring-jordans-summer-orange-dark focus:ring-offset-jordans-sea-blue',
        }"
      />
    </div>
  </div>
</template>
